exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".forgalmi-prefix[data-v-1d8890a2]{width:30px;min-height:30px;display:inline-flex;justify-content:center;align-items:center;background:var(--v-secondary-base);color:#fff;font-size:14px;font-weight:700;border-radius:4px;padding:4px}", ""]);

// exports
